import {s_r_e as lang} from '~/lang/ru'

/** @type { import('vue/types/options').FunctionalComponentOptions<{ act: import('./adapters/act').Act }> } */
export const RequestView = {
	functional: true,
	name: 'RequestView',
	props: {
		request: Object,
	},
	render(h, {props}) {
		return (
			<div>
				<p className="mb-4">
					<b>{lang('STATUS')}:</b> {props.request.status}
				</p>

				<p className="mb-4">
					<b>{lang('BRAND')}:</b> {props.request.brand}
				</p>

				<p className="mb-4">
					<b>{lang('MODEL')}:</b> {props.request.model}
				</p>

				<p className="mb-4">
					<b>{lang('SERIAL_NUMBER')}:</b> {props.request.serial}
				</p>

				{props.request.logistic.length > 0 ? (
					<p className="mb-4">
						<b>{lang('LOGISTIC')}</b>

						{props.request.logistic.map((item) => (
							<span class="block"> {item.START} => {item.FINISH}</span>
						))}
					</p>
				) : null}

				<p className="mb-4">
					<b>{lang('SERVICE_ADDRESS')}:</b> {props.request.service.ADDRESS}
				</p>

				{props.request.service.PHONES.length > 0 ? (
					<p className="mb-4">
						<b>{lang('SERVICE_PHONE')}</b>

						{props.request.service.PHONES.map((item) => (
							<a class="block" href="tel:{item}">{item}</a>
						))}
					</p>
				) : null}
			</div>
		)
	}
}
